import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { firstAllowedHomeUrl } from './home-redirect.guard';

/**
 * Cuando sea `true`, `permissionGuard` exige los roles de `route.data.permissions`
 * (`realm_access.roles` del access token).
 */
export const ENFORCE_ROUTE_PERMISSIONS = true;

/** Datos de ruta para filtrar por permiso Keycloak. */
export interface RoutePermissionData {
  /** Roles requeridos (todos). Vacío o ausente = cualquier usuario autenticado. */
  permissions?: string[];
}

function readPermissions(route: { data: Record<string, unknown> }): string[] | undefined {
  const value = route.data['permissions'];
  return Array.isArray(value) ? (value as string[]) : undefined;
}

function allowsPermissions(
  permissions: string[] | undefined,
  auth: AuthService,
  router: Router
): boolean {
  if (!ENFORCE_ROUTE_PERMISSIONS) {
    return true;
  }

  const required = permissions ?? [];
  if (required.length === 0) {
    return true;
  }

  if (auth.hasAllRoles(required)) {
    return true;
  }

  void router.navigateByUrl(firstAllowedHomeUrl(auth));
  return false;
}

/** Comprueba `data.permissions` de la ruta hija. No bloquea mientras ENFORCE_ROUTE_PERMISSIONS sea false. */
export const permissionGuard: CanActivateChildFn = (childRoute) => {
  return allowsPermissions(readPermissions(childRoute), inject(AuthService), inject(Router));
};
